import React from 'react';
import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router';

import styled from 'styled-components';

import ErrorBoundary from 'components/error/ErrorBoundary';
import { CommonPageStyled } from 'components/templates/layouts/web/CommonLayout';

import useScrollTop from 'hooks/common/useScrollTop';

import { mobileMenuBarConst } from 'constants/common/menu/mobileMenuBarConst';

import HeaderMobile from '../../header/mobile/HeaderMobile';

const MobileCommonLayout = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const viewMode = searchParams.get('view');

  const isMobileView = viewMode === 'mobile';

  const mobilePaths = mobileMenuBarConst
    .flatMap((item) =>
      item.content ? item.content.map((sub) => sub.path) : [item.path]
    )
    .filter(Boolean)
    .map((path) => path.split('?')[0]);

  const isMatchedPath =
    location.pathname === '/' ||
    [
      ...mobilePaths,
      '/auth-google',
      '/auth-kakao',
      '/auth-naver',
      '/sign-up',
      '/user',
    ].some((path) => location.pathname.startsWith(path));

  useScrollTop(); // 페이지 이동 시 상단 이동

  return isMatchedPath ? (
    <MobilePageStyled
      id="wrapper"
      className="trans-all-ease toggled"
      hidden={!isMobileView}
    >
      <HeaderMobile />
      <Outlet />
    </MobilePageStyled>
  ) : (
    <Navigate to="/?view=mobile" />
  );
};

export default MobileCommonLayout;

const MobilePageStyled = styled(CommonPageStyled)`
  background: ${({ theme }) => theme.color.white};
  ${({ hidden }) => hidden && 'display: none;'}
`;
